export const EventMarker = ({
  cx = 0,
  cy = 0,
}: {
  cx?: number;
  cy?: number;
}) => {
  return (
    <svg
      x={cx - 3}
      y={cy - 16}
      width="6"
      height="18"
      viewBox="0 0 6 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M3.3 5C3.3 4.83431 3.16569 4.7 3 4.7C2.83431 4.7 2.7 4.83431 2.7 5L3.3 5ZM3 14.4C2.11634 14.4 1.4 15.1163 1.4 16C1.4 16.8837 2.11634 17.6 3 17.6C3.88366 17.6 4.6 16.8837 4.6 16C4.6 15.1163 3.88366 14.4 3 14.4ZM2.7 5.6875C2.7 5.85319 2.83431 5.9875 3 5.9875C3.16569 5.9875 3.3 5.85319 3.3 5.6875L2.7 5.6875ZM3.3 7.0625C3.3 6.89681 3.16569 6.7625 3 6.7625C2.83431 6.7625 2.7 6.89681 2.7 7.0625L3.3 7.0625ZM2.7 8.4375C2.7 8.60319 2.83431 8.7375 3 8.7375C3.16569 8.7375 3.3 8.60319 3.3 8.4375L2.7 8.4375ZM3.3 9.8125C3.3 9.64681 3.16569 9.5125 3 9.5125C2.83431 9.5125 2.7 9.64681 2.7 9.8125L3.3 9.8125ZM2.7 11.1875C2.7 11.3532 2.83431 11.4875 3 11.4875C3.16569 11.4875 3.3 11.3532 3.3 11.1875L2.7 11.1875ZM3.3 12.5625C3.3 12.3968 3.16569 12.2625 3 12.2625C2.83431 12.2625 2.7 12.3968 2.7 12.5625L3.3 12.5625ZM2.7 13.9375C2.7 14.1032 2.83431 14.2375 3 14.2375C3.16569 14.2375 3.3 14.1032 3.3 13.9375L2.7 13.9375ZM3.3 15.3125C3.3 15.1468 3.16569 15.0125 3 15.0125C2.83432 15.0125 2.7 15.1468 2.7 15.3125L3.3 15.3125ZM2.7 5L2.7 5.6875L3.3 5.6875L3.3 5L2.7 5ZM2.7 7.0625L2.7 8.4375L3.3 8.4375L3.3 7.0625L2.7 7.0625ZM2.7 9.8125L2.7 11.1875L3.3 11.1875L3.3 9.8125L2.7 9.8125ZM2.7 12.5625L2.7 13.9375L3.3 13.9375L3.3 12.5625L2.7 12.5625ZM2.7 15.3125L2.7 16L3.3 16L3.3 15.3125L2.7 15.3125Z"
        fill="#051922"
      />
      <circle cx="3" cy="3" r="3" fill="#051922" />
      <circle cx="3" cy="3" r="1.5" fill="white" />
    </svg>
  );
};
